var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRsvInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.58398,
    y: 3.98486,
    width: 20.644,
    height: 5.28809,
    fill: "#00BF9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6734 3.81812H22.228V21.0908C22.228 21.5908 21.828 21.9999 21.3371 21.9999H2.66435C2.17344 21.9999 1.77344 21.5908 1.77344 21.0908V3.81812H5.32798",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33984 3.81812L15.6019 3.81812",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77379 2C7.52518 2 8.13743 2.51136 8.13743 3.13636V5.40909C8.13743 6.03409 7.52518 6.54545 6.77379 6.54545C6.0224 6.54545 5.41016 6.03409 5.41016 5.40909V3.13636C5.41016 2.51136 6.0224 2 6.77379 2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2279 2C17.9793 2 18.5915 2.51136 18.5915 3.13636V5.40909C18.5915 6.03409 17.9793 6.54545 17.2279 6.54545C16.4765 6.54545 15.8643 6.03409 15.8643 5.40909V3.13636C15.8643 2.51136 16.4765 2 17.2279 2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21875 9.27271H21.7824",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06152 13.728L17.8797 13.728",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06152 16.4551L13.3343 16.4551",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRsvInfo);
export default __webpack_public_path__ + "static/media/ic_rsv_info.0d252bd6c7257f4eb325300d2b8aee36.svg";
export { ForwardRef as ReactComponent };